import {IntermediatePart} from "../../intermediatePart";
import CenterIsland from "../../parts/centerIsland";

export default class Decor extends IntermediatePart {
  constructor(isChild, decorCount, dbFeature) {
    super(isChild);
    this.decorCount = decorCount;
    this.partId = "decor_" + decorCount;
    this.partName = "Decor " + decorCount;
    if (dbFeature && dbFeature.metaData && dbFeature.metaData["CIShape"]) {
      this.isCenterIslandDecor = true;
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Decor(false, this.decorCount));
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (this.isCenterIslandDecor) {
      const centerIslandParent = this.getParent().layout.parts[CenterIsland.id];
      if (centerIslandParent && centerIslandParent.cabinet) {
        if (centerIslandParent.cabinet.disabled) {
          conditions.push({
            propName: "CIShape",
            propValue: "noCI"
          })
        } else if (centerIslandParent.cabinet.activeFeature && centerIslandParent.cabinet.activeFeature.metaData["CIShape"]) {
          conditions.push({
            propName: "CIShape",
            propValue: centerIslandParent.cabinet.activeFeature.metaData["CIShape"][0]
          })
        }
      }
    }
    // console.log("conditions", conditions);
    return conditions
  }

}
